import { AppShop } from "@shop/frontend/web/js/classes/AppShop.js";
import api from "@shop/frontend/web/js/api";

import { utils } from "../utils";
import { Storage } from "../components/Storage";
import runFunctions from "@shop/frontend/web/js/shared/index.js";

/**
 *  Класс с вызовом общих методов, которые нужны на каждой странице
 * @extends AppShop
 */
export class App extends AppShop {
	constructor() {
		super();
		this.$body = $("body");
		this.$html = $("html");
		this.$modal = $("#js-popup-modal");
		this.$modals = $(".modal_enter");
		this.$topLevel = $(".js-has-dropdown");
		this.$headerProfile = $(".header__link_profile")[0];
		this.$menuNext = $(".js-menu-next");
		this.$loginModal = $("#loginModal");
		this.$recoveryModal = $("#recoveryModal");
		this.$registerModal = $("#registerModal");
		this.$fastRegisterModal = $("#fastRegisterModal");
		this.$accessModal = $("#accessModal");
		this.$dropdown = $(".dropdown");
		this.$closeAccess = $("#js-close-access");
		this.$access = $("#js-access");
		this.$accessRadio = $(".js-access-radio");
		this.$accessContent = $(".js-access-content");
		this.$accessHide = $("#js-access-hide");
		this.commonModalClose = $("#js-common-modal-close");
		this.$accessItem = $(".js-sphere-item");
		this.$dropdownSphere = $("#js-dropdown-sphere");
		this.$dropdownSphereBtn = this.$dropdownSphere.find(".dropdown__btn");
		this.$accessSelect = $("#requestadmin-activity_sphere");
		this.$accessOptions = this.$accessSelect.find("option");
		this.$enterInputs = $(".form-group input");
		this.$printPdfBtn = $("#printPdfBtn"); //Кнопка распечать в истории покупок
		this.$fastInputEmail = $(".js-input-email-fast");
		this.$infoMobile = $(".js-info-mobile");
		this.storage = new Storage();
		super.initShop();
	}

	init() {
		runFunctions();
		this.setUpListeners();
		this.getFastRegistration();
		this.addActionToProfile();
		this.setCityToCookie();
		this.initToggleActiveClass();
		this.initTicketReturn();
		window.storage = this.storage;
	}

	setUpListeners() {
		this.$modal.on("hide.bs.modal", () => {
			this.$modal.removeClass("modal_subscription modal_place");
		});

		this.$modals.on("show.bs.modal", () => {
			this.$html.css("overflow", "hidden");
		});

		this.$modals.on("hide.bs.modal", () => {
			this.$html.css("overflow", "");
		});

		$(".modal form").on("submit", e => {
			const form = $(e.currentTarget);
			form.find("button[type='submit']").addClass("disabled");
		});

		$(".enter__input ").on("input", () => {
			$(".modal form button[type='submit']").removeClass("disabled");
		});

		$(document).on("click", ".js-login-back", () => {
			this.$recoveryModal.modal("hide");
			this.$loginModal.modal("show");
		});

		function setBodyVisible() {
			$("body").addClass("modal-open");
		}

		$(".js-enter-register").on("click", () => {
			this.$loginModal.modal("hide");
			this.$accessModal.modal("hide");
			setTimeout(setBodyVisible, 600);
		});

		$(".js-get-access-modal").on("click", e => {
			this.$loginModal.modal("hide");
			this.$registerModal.modal("hide");
			const initial = $(e.currentTarget).data("initial");
			$(".access-request__link").hide();
			$(`.access-request__link[data-initial="${initial}"]`).show();
			setTimeout(setBodyVisible, 600);
		});

		$(".js-enter-recovery").on("click", () => {
			this.$loginModal.modal("hide");
			setTimeout(setBodyVisible, 600);
		});

		$(".js-enter-login").on("click", () => {
			this.$registerModal.modal("hide");
			this.$fastRegisterModal.modal("hide");
			this.$accessModal.modal("hide");
			this.$modal.modal("hide");
			setTimeout(setBodyVisible, 600);
		});

		this.$infoMobile.on("click", e => {
			const element = $(e.currentTarget);
			const dataSelector = element.data("info");
			$(`.info__text[data-info="${dataSelector}"]`).toggleClass("active");
		});

		$(".checkbox__input").on("keydown", e => {
			const element = $(e.currentTarget);

			if (e.code === "Enter" || e.code === "NumpadEnter") {
				element.toggleClass("checked");

				if ($(element).hasClass("checked")) {
					$(element).prop("checked", true);
				} else {
					$(element).prop("checked", false);
				}
			}
		});

		this.commonModalClose.on("click", () => {
			if (window.location.pathname.includes("event")) {
				window.location.assign("/");
			}
		});

		$(document).on("click", ".enter__close", () => {
			if (window.location.pathname.includes("event") && !this.isDesktop.matches) {
				window.location.assign("/");
			}
		});

		$(document).on("click", "#js-hide-play-info", e => {
			const element = $(e.currentTarget);
			const parent = element.parents(".play-info");
			parent.remove();
		});

		$(document).on("click", ".js-enter-visible-password", e => {
			const element = $(e.currentTarget);
			const input = element.parents(".enter__block").find(".enter__input");
			element.toggleClass("active");

			if (input.attr("type") === "text") {
				input.attr("type", "password");
				element.attr(
					"aria-label",
					"Show password as plain text. " +
						"Warning: this will display your password on the screen."
				);
			} else {
				input.attr("type", "text");
				element.attr("aria-label", "Hide password.");
			}
		});

		this.$closeAccess.on("click", () => {
			this.$access.slideUp();
		});

		this.$accessRadio.on("change", e => {
			const element = $(e.currentTarget);
			const type = element.val();
			this.$accessContent.hide();
			$(`.js-access-content[data-type='${type}']`).show();
		});

		this.$accessHide.on("click", () => {
			this.$access.slideUp();
			utils.setCookie("accessHide", true, { path: "/", "max-age": "36000000" });
		});

		$(document).on("mouseout", ".js-hover-out", e => {
			const element = $(e.currentTarget);
			element.blur();
		});

		this.$accessItem.on("click", e => {
			const element = $(e.currentTarget);
			const index = element.index() + 1;
			const selectedText = element.text();
			this.$accessSelect[0][index].selected = true;
			this.$dropdownSphere.ariaDropdown("slideUp");
			this.$dropdownSphereBtn.find("span").text(selectedText);
		});

		$(document).on("click", ".js-event-more", e => {
			const element = $(e.currentTarget);
			const parent = element.parents(".js-text-parent");
			element.toggleClass("active");
			parent.find(".js-event-text").slideToggle();
		});

		$.each(this.$enterInputs, (i, item) => {
			const element = $(item);
			if (element.val()) {
				element.next().addClass("inactive");
			}
		});

		this.$enterInputs.on("input", e => {
			const element = $(e.currentTarget);
			element.next().addClass("inactive");
			if (!element.val()) {
				element.next().removeClass("inactive");
			}
		});

		this.$enterInputs.on("click", e => {
			const element = $(e.currentTarget);
			element.next().addClass("inactive");
		});

		this.$enterInputs.on("blur", e => {
			const element = $(e.currentTarget);
			if (!element.val()) {
				element.next().removeClass("inactive");
			}
		});

		this.$printPdfBtn.on("click", e => {
			const element = $(e.currentTarget); //this button
			const pdfSrc = $(element).attr("data-pdf-src"); //pdf path
			const objFra = document.createElement("iframe"); // Create an IFrame.
			objFra.style.visibility = "hidden"; // Hide the frame.
			objFra.src = pdfSrc; // Set source.
			document.body.appendChild(objFra); // Add the frame to the web page.
			objFra.contentWindow.focus(); // Set focus.
			objFra.contentWindow.print(); // Print it.
		});

		this.$fastInputEmail.on("change", e => {
			const element = $(e.currentTarget);
			const email = element.val();
			this.checkUser(email).then(user => {
				const form = element.parents("form");
				const second = form.find(".js-fast-second")[0];
				const first = form.find(".js-fast-first")[0];
				const phone = form.find(".js-fast-phone")[0];
				second.value = user.second;
				first.value = user.first;
				phone.value = user.phone;
			});
		});

		$("#questionary-form")
			.find("input.input-line")
			.on("change", e => {
				const elem = $(e.currentTarget);
				$(elem).parent().find("input[type=radio]").val($(elem).val());
			});
	}

	getFastRegistration() {
		$(document).on("click", ".js-places-buy", e => {
			const el = $(e.currentTarget);
			e.preventDefault();
			this.$fastRegisterModal.detach().appendTo("body").modal();
			const sum = el.parents(".js-order").find(".js-sum").text();
			$(".js-sum-fast").text(sum);
			let action = $("#fast-registration-controller").attr("action");
			const eventId = el.data("event-id");
			const resultID = action.match(/event_id=\d*/);
			action = action.replace(resultID, `event_id=${eventId}`);
			$("#fast-registration-controller").attr("action", action);
		});
	}

	addActionToProfile() {
		if (this.isDesktop.matches && this.$headerProfile) {
			if (this.$headerProfile.nextElementSibling) {
				this.$headerProfile.addEventListener("focus", () => {
					this.$headerProfile.parentNode.classList.add("focus");
				});
				this.$headerProfile.addEventListener("blur", () => {
					this.$headerProfile.parentNode.classList.remove("focus");
				});
				const subMenu = this.$headerProfile.nextElementSibling;
				const subMenuLinks = subMenu.querySelectorAll("a");
				const lastLinkIndex = subMenuLinks.length - 1;
				const lastLink = subMenuLinks[lastLinkIndex];

				lastLink.addEventListener("blur", () => {
					this.$headerProfile.parentElement.classList.remove("focus");
				});
			}
			$(document).mouseup(e => {
				const container = $(".header__auth");
				if (!container.is(e.target) && container.has(e.target).length === 0) {
					$(".header__link_profile").removeClass("focus");
				}
			});
		}
	}

	setCityToCookie() {
		$(".js-city-name").on("click", e => {
			const element = $(e.currentTarget);
			const city = element.data("id");
			utils.setCookie("city_id", city, { path: "/", "max-age": "36000000" });
			window.location.assign("/");
		});
	}

	initTicketReturn() {
		if (!$(".js-ticket-return").length > 0) return false;

		$(".js-ticket-return").on("click", e => {
			const $element = $(e.currentTarget);
			const orderId = $element.data("order");
			const eventId = $element.data("event");
			const fragment = document.importNode($("#js-template-refund")[0].content, true);
			const returnConfirm = $(fragment).find("#js-return-confirm");
			returnConfirm.data("order", orderId);
			returnConfirm.data("event", eventId);
			$("#js-popup-modal").find(".modal-body").html(fragment);
			$("#js-popup-modal").addClass("modal_refund");
			$("#js-popup-modal").modal();
		});

		$(document).on("click", "#js-return-confirm", e => {
			const $element = $(e.currentTarget);
			const orderId = $element.data("order");
			const eventId = $element.data("event");

			api.refund
				.refund({ orderId, eventId })
				.then(res => {
					if (!res.success) throw new Error(res.message);

					const fragment = document.importNode(
						$("#js-template-refund-success")[0].content,
						true
					);
					$("#js-popup-modal")
						.addClass("modal_refund-success")
						.find(".modal-body")
						.html(fragment);
					const ticketReturn = $(
						`.js-ticket-return[data-event="${eventId}"][data-order="${orderId}"]`
					);
					const order = $(`.js-order[data-id="${orderId}"]`);
					const event = order.find(`.order__sub-event[data-event-id="${eventId}"]`);
					const countEvents = order.find(".js-order-event").length;
					const $historyButtons = order.find(".history__buttons");
					event.find(".js-was-refund").show();
					if (countEvents == 1) $($historyButtons).remove();
					ticketReturn.remove();
				})
				.catch(err => {
					console.log(err);
					alert(`Произошла ошибка!\n${err.message || "Неизвестная ошибка с сервера!"}`);
				});
		});
	}

	initToggleActiveClass() {
		$(document).on("click", ".js-toggle-active", e => {
			const target = $(e.currentTarget).data("toggle-target");

			$(e.currentTarget).toggleClass("active");

			if (target) return $(target).toggleClass("active");
		});
	}
}
